module.exports = __webpack_public_path__ + "img/twitter.2cb62523.svg";